import React, { FC, memo } from 'react'
import { ChevronLeftIcon } from '../../common/icons'
import { AnyStyledComponent } from 'styled-components'
import { CarouselIcon, StyledCarouselBackButton } from './styles'
import { stopPropagation } from '../../../utils/dom-utils'

const CarouselButtonBack: FC<{}> = () => {
    return (
        <div onClick={stopPropagation}>
            <StyledCarouselBackButton $left>
                <CarouselIcon as={ChevronLeftIcon as AnyStyledComponent} />
            </StyledCarouselBackButton>
        </div>
    )
}

export default memo(CarouselButtonBack)
